<template>
  <v-app class="pfm-global pfo">
    <Launcher
    :isFABRight="isFABRight"
    :isFABLarge="isFABLarge"
    />
  </v-app>
</template>

<script>
import Launcher from "./components/Launcher"

export default {
  name: "App",
  components: {
    Launcher
  },
  data() {
    return {
      isFABRight: false,
      isFABLarge: true
    }
  },
  created() {
    this.isFABRight = true
    if (process.env.VUE_APP_ISFABRIGHT==="false") {
      this.isFABRight = false
    }

    if ( process.env.VUE_APP_AUTORELOAD == 'true') {
      var time
      const resetTimer = () => {
          clearTimeout(time)
          time = setTimeout(() => window.location.reload(false), process.env.VUE_APP_RELOAD_IDLE_TIME)
      }
      window.onload = resetTimer
      document.onmousemove = resetTimer
      document.onkeydown = resetTimer
      document.onscroll = resetTimer
      document.onpointermove = resetTimer
      document.addEventListener("touchmove", resetTimer, false)

    }

    this.isFABLarge = true
    if (process.env.VUE_APP_ISFABLARGE==="false") {
      this.isFABLarge = false
    }
  }
}
</script>

<style>
  .pfm-global {
    position: absolute;
    z-index: 2147483647;
    font-family: 'Roboto', sans-serif;
    line-height: unset;
  }
  /* Hide scrollbar for Chrome, Safari and Opera */
div::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
div {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>

<style lang="scss">
.pfo-vue {
  // @import '../node_modules/vuetify/dist/vuetify.css';
}
</style>